import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import TextField from "../fields/TextField";
import SelectField from "../fields/SelectField";
import { buildOptions } from "../utils";

class MedicalHistoryFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  render() {

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Medical History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <SelectField
              name="diagnosis_list"
              label="Diagnosis"
              action="edit"
              col={6}
              options={this.props.mental_disorders_options}
              creatable
              isMulti />
            <SelectField
              name="substances_of_choice_list"
              label="Substances of Choice"
              action="edit"
              col={6}
              options={this.props.substances_of_choice_options}
              creatable
              isMulti />
            <SelectField
              name="health_problem_list"
              label="Health Problems"
              action="edit"
              col={6}
              options={this.props.health_problem_options}
              creatable
              isMulti />
            <SelectField
              name="allergy_type_list"
              label="Allergies"
              action="edit"
              col={6}
              options={this.props.allergies_options}
              creatable
              isMulti
            />
            {this.props.allergies &&
              <TextField name="allergies" label="Allergies" action="edit" col={6} />
            }
            <TextField name="medical_notes" label="Notes" action="edit" col={12} />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="info"
            onClick={() => this.props.closeModal()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.medicalHistoryModal.show,
    substances_of_choice_options: buildOptions(state.org_dependant_data.substances_of_choice_options),
    mental_disorders_options: buildOptions(state.org_dependant_data.mental_disorders_options),
    health_problem_options: buildOptions(state.org_dependant_data.health_problem_options),
    allergies_options: buildOptions(state.org_dependant_data.allergies_options),
    allergies: state.resident.allergies,
    hasDelete: state.current_user.permissions.includes("Delete"),
    hasEdit: state.current_user.permissions.includes("Edit")
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "medicalHistory" } })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MedicalHistoryFormModal);
